import { useApp } from '../context.js';
import { AVATAR_EMOJI } from '../presets.js';

export default function ProfilePhotoModal() {
    const { handleProfilePhotoUpload, haptic, profilePhotos, removeProfilePhoto, saveProfilePhoto, setShowProfilePhotoUpload, showProfilePhotoUpload } = useApp();
    if (!showProfilePhotoUpload) return null;
    return (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowProfilePhotoUpload(null)}>
            <div className="bg-white rounded-2xl p-6 max-w-xs w-full shadow-xl" onClick={(e) => e.stopPropagation()}>
                <h3 className="text-lg font-bold text-gray-800 mb-4 text-center">
                    {showProfilePhotoUpload === 'doug' ? "Doug's" : "Les's"} Photo
                </h3>

                <div className="flex flex-col items-center gap-4">
                    {profilePhotos[showProfilePhotoUpload] ? (
                        <img src={profilePhotos[showProfilePhotoUpload]} alt="Current" className="w-24 h-24 rounded-full object-cover shadow-md" />
                    ) : (
                        <div className={`w-24 h-24 rounded-full flex items-center justify-center text-4xl font-bold text-white ${showProfilePhotoUpload === 'doug' ? 'bg-gradient-to-br from-blue-400 to-indigo-500' : 'bg-gradient-to-br from-pink-400 to-rose-500'}`}>
                            {showProfilePhotoUpload === 'doug' ? 'D' : 'L'}
                        </div>
                    )}

                    {/* Preset Avatar Options */}
                    <div>
                        <p className="text-xs text-gray-500 text-center mb-2">Choose an avatar:</p>
                        <div className="flex gap-2 justify-center flex-wrap">
                            {(showProfilePhotoUpload === 'doug'
                                ? AVATAR_EMOJI.doug
                                : AVATAR_EMOJI.les
                            ).map((emoji) => (
                                <button
                                    key={emoji}
                                    onClick={() => {
                                        // Create an emoji avatar as base64
                                        const canvas = document.createElement('canvas');
                                        canvas.width = 200;
                                        canvas.height = 200;
                                        const ctx = canvas.getContext('2d');

                                        // Draw gradient background circle
                                        const gradient = ctx.createLinearGradient(0, 0, 200, 200);
                                        if (showProfilePhotoUpload === 'doug') {
                                            gradient.addColorStop(0, '#60A5FA');
                                            gradient.addColorStop(1, '#6366F1');
                                        } else {
                                            gradient.addColorStop(0, '#F472B6');
                                            gradient.addColorStop(1, '#F43F5E');
                                        }
                                        ctx.fillStyle = gradient;
                                        ctx.beginPath();
                                        ctx.arc(100, 100, 100, 0, Math.PI * 2);
                                        ctx.fill();

                                        // Draw emoji with system emoji font
                                        ctx.font = '90px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif';
                                        ctx.textAlign = 'center';
                                        ctx.textBaseline = 'middle';
                                        ctx.fillText(emoji, 100, 108);

                                        const base64 = canvas.toDataURL('image/png');
                                        saveProfilePhoto(showProfilePhotoUpload, base64);
                                        setShowProfilePhotoUpload(null);
                                        haptic('success');
                                    }}
                                    className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center text-2xl hover:bg-gray-200 apple-button"
                                >
                                    {emoji}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="w-full space-y-2 border-t pt-4">
                        <label className="block w-full">
                            <span className="sr-only">Choose photo</span>
                            <input
                                type="file"
                                accept="image/*"
                                capture="user"
                                onChange={(e) => handleProfilePhotoUpload(e, showProfilePhotoUpload)}
                                className="hidden"
                                id="profile-photo-input"
                            />
                            <div
                                onClick={() => document.getElementById('profile-photo-input').click()}
                                className="w-full bg-blue-500 text-white px-4 py-3 rounded-xl font-semibold apple-button text-center cursor-pointer"
                            >
                                Take Photo
                            </div>
                        </label>

                        <label className="block w-full">
                            <input
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleProfilePhotoUpload(e, showProfilePhotoUpload)}
                                className="hidden"
                                id="profile-gallery-input"
                            />
                            <div
                                onClick={() => document.getElementById('profile-gallery-input').click()}
                                className="w-full bg-gray-100 text-gray-700 px-4 py-3 rounded-xl font-semibold apple-button text-center cursor-pointer"
                            >
                                Choose from Gallery
                            </div>
                        </label>

                        {profilePhotos[showProfilePhotoUpload] && (
                            <button
                                onClick={() => removeProfilePhoto(showProfilePhotoUpload)}
                                className="w-full bg-red-50 text-red-600 px-4 py-3 rounded-xl font-semibold apple-button"
                            >
                                Remove Photo
                            </button>
                        )}
                    </div>

                    <button
                        onClick={() => setShowProfilePhotoUpload(null)}
                        className="text-gray-500 text-sm"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}
